/**
 * The Localisation route table (FSD 1.2.8: e-invoicing configuration, sandbox
 * pack-validation runs, statutory document languages).
 *
 * `web/src/router/index.ts` and `web/src/nav/parts/p01-enterprise.ts` are
 * shared files several sibling C14 W3 packets also touch and this packet does
 * NOT own — the orchestrator spreads `LOCALISATION_ROUTES` into the router
 * and adds the nav entry once every packet in this batch has landed.
 *
 * Every route is gated on the **read** half of its permission pair, matching
 * `web/src/modules/enterprise/reference-sets/routes.ts`'s convention: a
 * Compliance Officer or Tax Manager holding only read access opens every
 * screen here and changes nothing.
 */

import type { RouteRecordRaw } from 'vue-router'

import { LOCALISATION_PERMISSIONS } from './permissions'

export const LOCALISATION_BASE = '/enterprise/localisation'

export function einvoicingRoute(): string {
  return `${LOCALISATION_BASE}/einvoicing`
}

export function sandboxRunsRoute(): string {
  return `${LOCALISATION_BASE}/sandbox-runs`
}

export function sandboxRunRoute(id: number): string {
  return `${LOCALISATION_BASE}/sandbox-runs/${id}`
}

export function statutoryLanguagesRoute(): string {
  return `${LOCALISATION_BASE}/statutory-languages`
}

export const LOCALISATION_ROUTES: RouteRecordRaw[] = [
  {
    path: einvoicingRoute(),
    name: 'enterprise-localisation-einvoicing',
    component: () => import('./EInvoicingConfigsView.vue'),
    meta: {
      titleKey: 'enterprise.localisation.routeTitles.einvoicing',
      permission: LOCALISATION_PERMISSIONS.einvoicingRead,
    },
  },
  {
    path: sandboxRunsRoute(),
    name: 'enterprise-localisation-sandbox-runs',
    component: () => import('./SandboxRunsView.vue'),
    meta: {
      titleKey: 'enterprise.localisation.routeTitles.sandboxRuns',
      permission: LOCALISATION_PERMISSIONS.sandboxRunRead,
    },
  },
  {
    path: `${sandboxRunsRoute()}/:id(\\d+)`,
    name: 'enterprise-localisation-sandbox-run',
    component: () => import('./SandboxRunDetailView.vue'),
    meta: {
      titleKey: 'enterprise.localisation.routeTitles.sandboxRunDetail',
      permission: LOCALISATION_PERMISSIONS.sandboxRunRead,
    },
  },
  {
    path: statutoryLanguagesRoute(),
    name: 'enterprise-localisation-statutory-languages',
    component: () => import('./StatutoryLanguagesView.vue'),
    meta: {
      titleKey: 'enterprise.localisation.routeTitles.statutoryLanguages',
      permission: LOCALISATION_PERMISSIONS.statutoryLanguageRead,
    },
  },
]
